const Newsletter = () => {
  const normalizedData = {

  }

  return normalizedData
}

export default Newsletter
